module.exports = __webpack_public_path__ + "img/rank3_2.2e6cea55.png";